/**
 * Creates a new object by omitting specified keys for the given object.
 *
 * @param object - The source object from which keys wil be removed
 * @param keys - An array of keys to be removed from the source object
 * @returns A new object with the specified keys omitted.
 *
 * @template T - The type of the source object.
 * @template K - The type of keys that will be removed from the object.
 */

export function omit<T extends object, K extends keyof T>(
  data: T,
  keys: K[]
): Omit<T, K> {
  const nextData = { ...data };

  keys.forEach((key) => {
    delete nextData[key];
  });

  return nextData;
}
